import React, { useContext } from "react";
import styled from "styled-components";
import { EventContext } from "Components";
import { Layout, BodySection } from "../Layout";
import { fonts } from "theme/fonts";

export const PreCampaign = () => {
  const { event } = useContext(EventContext);

  return (
    <Layout showHeader showFooter>
      <StyledBodySection>
        <p>{event.preCampaign.body}</p>
      </StyledBodySection>
    </Layout>
  );
};

const StyledBodySection = styled(BodySection)`
  padding: 15px;
  text-align: center;

  p {
    font-size: clamp(24px, 5vw, 48px);
    text-transform: uppercase;
    font-family: ${fonts.header};
  }
`;
